import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import NavigationAnchor from './NavigationAnchor';
import type { ICategoryNode } from './types';

interface IProps extends ICategoryNode {
  onClick: (node: ICategoryNode) => void;
  onBack: () => void;
  selectedNodeId?: string;
}

const Wrapper: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <div className="flex flex-col border-b border-gray-100">{children}</div>
);

export default function CategoryGridItem({ onClick, onBack, selectedNodeId, ...node }: IProps) {
  return (
    <Wrapper>
      <div className="flex justify-start gap-x-2">
        <NavigationAnchor
          href={node.categoryUrl}
          title={node.categoryName}
          onClick={e => {
            if (node.nodes.length > 0) {
              e.preventDefault();
              onClick(node);
            }
          }}>
          <span>{node.categoryName}</span>
        </NavigationAnchor>

        {node.nodes.length > 0 && (
          <button
            onClick={() => onClick(node)}
            className={`inline-flex items-center justify-center ml-auto text-primary px-4 py-2`}
            type="button">
            <i className="fa-solid fa-angle-right"></i>
          </button>
        )}
      </div>

      {node.nodes.length > 0 && (
        <div
          className={`absolute top-0 -right-full w-full ${
            selectedNodeId === node.categoryId ? 'block' : 'hidden'
          }`}>
          {selectedNodeId && (
            <button
              className="w-full flex items-center p-4 font-medium bg-gray-50"
              role="button"
              onClick={onBack}>
              Na hlavné kategórie
              <i className="fa-solid fa-angle-left text-primary ml-auto"></i>
            </button>
          )}
          <div className="grid">
            {node.nodes.map(node => (
              <Wrapper key={node.categoryId}>
                <NavigationAnchor href={node.categoryUrl} title={node.categoryName}>
                  <span>{node.categoryName}</span>
                </NavigationAnchor>
              </Wrapper>
            ))}
          </div>
        </div>
      )}
    </Wrapper>
  );
}
